import PropTypes from 'prop-types';
import account from '#props/account';

export default {
  dispatch: PropTypes.func,
  account: PropTypes.shape(account)
};
